export const allowDisplay = (permissions) => {
    const role = localStorage.role;
    if (role) {
        return permissions.includes(role);
    }
    return false;
};

export const adaptedName = (name) => {
    return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
};

export function convertToPseudocode(node) {
    let pseudocode = '';

    if (node.type === 'condition') {
        const condition = node.condition;
        if (node.conditionType === 'IF') {
            pseudocode += `if (${condition}) {\n`;
        } else if (node.conditionType === 'ELSE') {
            pseudocode += `else (${condition}) {\n`;
        } else if (node.conditionType === 'ELSE IF') {
            pseudocode += `else if (${condition}) {\n`;
        }

        for (const child of node.children) {
            pseudocode += convertToPseudocode(child);
        }

        pseudocode += '}\n';
    } else if (node.type === 'action') {
        const action = node.action;
        pseudocode += `  ${action}\n`;
    }

    return pseudocode;
}
// const findLastElement = (node) => {
//     console.log('find last el: node', node);
//     if (node.children.length === 0) return node;
//
//     const lastChild = node.children[node.children.length - 1];
//     return findLastElement(lastChild);
// };

export function convertToTree(pseudocode) {
    if (!pseudocode || pseudocode === '' || pseudocode === '{}') {
        return {
            type: 'condition',
            conditionType: 'IF',
            condition: '',
            children: [],
            selected: false,
            expanded: false,
            uuid: crypto.randomUUID()
        };
    }

    const lines = pseudocode
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    const root = {
        children: []
    };
    const stack = [root];

    lines.forEach((line) => {
        const currentContext = stack[stack.length - 1];

        if (line.startsWith('if')) {
            const condition = line.substring(4, line.indexOf(')')).trim();
            const newNode = {
                type: 'condition',
                conditionType: 'IF',
                condition: condition,
                children: [],
                selected: true,
                expanded: true,
                uuid: crypto.randomUUID()
            };
            currentContext.children.push(newNode);
            stack.push(newNode);
        } else if (line.startsWith('else if')) {
            const condition = line.substring(8, line.indexOf(')')).trim();
            const newNode = {
                type: 'condition',
                conditionType: 'ELSE IF',
                condition: condition,
                selected: true,
                expanded: true,
                children: [],
                uuid: crypto.randomUUID()
            };
            currentContext.children.push(newNode);
            stack.push(newNode);
        } else if (line.startsWith('else') || line.includes('else {')) {
            const newNode = {
                type: 'condition',
                conditionType: 'ELSE',
                condition: '',
                selected: true,
                expanded: true,
                children: [],
                uuid: crypto.randomUUID()
            };
            currentContext.children.push(newNode);
            stack.push(newNode);
        } else if (line === '}') {
            stack.pop();
        } else {
            const newNode = {
                type: 'action',
                children: [],
                action: line,
                selected: true,
                expanded: true,
                uuid: crypto.randomUUID()
            };
            currentContext.children.push(newNode);
        }
    });

    let tree = root.children[0];

    return tree;
}

// export function convertToTree(pseudocode) {
//     if (!pseudocode) {
//         return {
//             type: "condition",
//             conditionType: "IF",
//             condition: "",
//             children: [],
//             selected: false,
//             expanded: false,
//             uuid: crypto.randomUUID()
//         };
//     }
//     const lines = pseudocode.split("\n");
//
//     let tree = {
//         type: "condition",
//         conditionType: "IF",
//         condition: "",
//         children: [],
//         selected: false,
//         expanded: false,
//         uuid: crypto.randomUUID()
//     };
//     let current = tree;
//
//     for (const line of lines) {
//         if (line.startsWith("if")) {
//             const condition = line.slice(3, -3);
//             const newNode = {
//                 type: "condition",
//                 conditionType: "IF",
//                 condition: condition,
//                 children: [],
//                 selected: false,
//                 expanded: false,
//                 uuid: crypto.randomUUID()
//             };
//             current.children.push(newNode);
//             current = newNode;
//         } else if (line.startsWith("else if")) {
//             const condition = line.slice(7, -3);
//             const newNode = {
//                 type: "condition",
//                 conditionType: "ELSE IF",
//                 condition: condition,
//                 children: [],
//                 selected: false,
//                 expanded: false,
//                 uuid: crypto.randomUUID()
//             };
//             current.children.push(newNode);
//             current = newNode;
//         } else if (line.startsWith("else")) {
//             const newNode = {
//                 type: "condition",
//                 conditionType: "ELSE",
//                 condition: "",
//                 children: [],
//                 selected: false,
//                 expanded: false,
//                 uuid: crypto.randomUUID()
//             };
//             current.children.push(newNode);
//             current = newNode;
//         } else if (line.startsWith("    ")) {
//             const action = line.slice(4, -1);
//             const newNode = {
//                 type: "action",
//                 action: action,
//                 selected: false,
//                 expanded: false,
//                 uuid: crypto.randomUUID()
//             };
//             current.children.push(newNode);
//         } else if (line === "}") {
//             current = tree;
//         }
//     }
//
//     return tree;
// }
